import http from "../../services/http";

const getAllActiveRolesApi = async () => {
  return await http("get", `v1/cargos/getAllActive`);
};

export { getAllActiveRolesApi };
